import React, { useMemo, useContext, useState } from "react";
import { ToastNotification, TOAST_TYPE } from "@acadia-ui/toast";
import { DataTableContext } from "../Tabs/Overview";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import { ViewMasterCampaignsContext } from "../index";
import DownloadCampaignsModal from "../../Modals/DownloadCampaignsModal";
import RequestHelpers from "../../../Helpers/RequestHelpers";
import Modal from "@acadia-ui/modal";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import { downloadCampaigns, getCampaignDownloads } from "../../../Flux/Actions/MasterCampaignActions";

export default () => {
	// Import various contexts
	const { checkboxSelections, dataProvider } = useContext(DataTableContext);
	const { addBanner } = useContext(ViewMasterCampaignsContext);

	const [isLoading, setIsLoading] = useState(false);

	const selectAllState = useMemo(() => {
		const selectionStateMap = { true: 1, indeterminate: 0, false: -1 };
		const rawValue = checkboxSelections.dataTableApi.current.rowSelectionManager.tree.selectionState;
		return selectionStateMap[rawValue];
	}, [checkboxSelections]);

	const handleDownload = async () => {
		if (checkboxSelections) {
			try {
				setIsLoading(true);
				addBanner(
					<ToastNotification
						type={TOAST_TYPE.INFO}
						message="Your export is now running in the background. Check the Campaign Download side sheet for progress."
						timed={5000}
					/>
				);
				const { searchQuery: search, filters } = dataProvider.resolveParams();
				await downloadCampaigns({ search: search || "", filters: filters || {}, selectAllState, checkboxSelections });
				document.getElementById("refresh-downloads")?.click();
			} catch (e) {
				addBanner(<ToastNotification type={TOAST_TYPE.ERROR} message="An error occurred while downloading the selected campaigns. Please try again." />);
			} finally {
				setIsLoading(false);
			}
		}
	};

	const disabled = useMemo(() => {
		return checkboxSelections?.selectedActivationCampaigns?.length == 0;
	}, [checkboxSelections]);

	const Trigger = () => (
		<Tooltip title="Download" position={TOOLTIP_POSITION.BOTTOM}>
			<Button
				display={BUTTON_DISPLAY.ICON_BORDERED}
				size={BUTTON_SIZE.SMALL}
				icon={"icon-download"}
				onClick={() => {
					Modal.show("downloadCampaignModal");
				}}
				disabled={disabled || isLoading}
				id="downloadCampaignButton"
				data-tracking-id-alt="download-campaign-button"
			>
				Download
			</Button>
		</Tooltip>
	);

	const DisplayedComponent = () => {
		return <DownloadCampaignsModal handleDownload={handleDownload} selectAllState={selectAllState} />;
	};

	// Return a memoized object containing both of these components
	return useMemo(() => ({ Trigger, DisplayedComponent }), [disabled, checkboxSelections, isLoading]);
};
